import React from 'react';
import Link from 'next/link';
import AppImage from '@/components/ui/AppImage';

export default function Footer() {
  const newsItems = [
    { date: '30 Des 2025', title: 'Terima Bantuan Program PKT 2025 dari DPPKUKM Kalimantan Timur' },
    { date: '24 Sep 2025', title: 'Agro Teknologi Nusantara Terima 14 Peserta Magang Smart Farming dari BPVP Samarinda' },
    { date: '21 Agt 2025', title: 'Agro Teknologi Nusantara Dampingi Petani Milenial Terapkan Smart Farming' },
  ];

  return (
    <footer className="border-t border-chartreuse/15 bg-canopy py-16 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        {/* Main footer grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Kolom 1 — Kebijakan */}
          <div>
            <div className="annotation mb-4">KEBIJAKAN</div>
            <div className="flex flex-col gap-2">
              {[
                { label: 'Kebijakan Privasi', href: '/kebijakan-privasi' },
                { label: 'Syarat & Ketentuan', href: '/syarat-ketentuan' },
                { label: 'Kebijakan Refund', href: '/kebijakan-refund' },
                { label: 'FAQ', href: '/faq' },
              ].map((item) => (
                <Link
                  key={item.label}
                  href={item.href}
                  className="font-mono text-xs tracking-wide text-text-muted hover:text-chartreuse transition-colors py-1"
                >
                  {item.label}
                </Link>
              ))}
            </div>
            {/* Trust seal */}
            <div className="mt-6 flex items-center gap-2 opacity-50">
              <div className="w-5 h-5 rounded-full border border-chartreuse/40 flex items-center justify-center">
                <span className="font-mono text-chartreuse text-[8px]">SSL</span>
              </div>
              <span className="font-mono text-[10px] text-text-muted tracking-wide">PositiveSSL Secured</span>
            </div>
          </div>

          {/* Kolom 2 — Menu */}
          <div>
            <div className="annotation mb-4">MENU</div>
            <div className="flex flex-col gap-2">
              {[
                { label: 'Landing', href: '/' },
                { label: 'Tentang', href: '/#about' },
                { label: 'Layanan', href: '/#services' },
                { label: 'Program', href: '/#program' },
                { label: 'Berita', href: '/#news' },
                { label: 'Hubungi Kami', href: '/quote' },
              ].map((item) => (
                <Link
                  key={item.label}
                  href={item.href}
                  className="font-mono text-xs tracking-wide text-text-muted hover:text-chartreuse transition-colors py-1"
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Kolom 3 — Berita Terbaru */}
          <div>
            <div className="annotation mb-4">BERITA TERBARU</div>
            <div className="flex flex-col gap-4">
              {newsItems.map((news, i) => (
                <div key={i} className="border-l border-chartreuse/20 pl-3">
                  <div className="font-mono text-[9px] text-chartreuse/60 tracking-widest mb-1">{news.date}</div>
                  <Link
                    href="/#news"
                    className="font-mono text-xs text-text-muted hover:text-chartreuse transition-colors leading-snug line-clamp-2"
                  >
                    {news.title}
                  </Link>
                </div>
              ))}
              <Link
                href="/#news"
                className="font-mono text-[10px] text-chartreuse tracking-widest uppercase mt-2 hover:underline"
              >
                Baca Selengkapnya →
              </Link>
            </div>
          </div>

          {/* Kolom 4 — Kontak */}
          <div>
            <div className="annotation mb-4">KONTAK</div>
            <div className="flex flex-col gap-3">
              <div className="flex items-start gap-2">
                <span className="font-mono text-[10px] text-chartreuse w-8">Telp</span>
                <a
                  href="tel:+6281253837777"
                  className="font-mono text-xs text-text-muted hover:text-chartreuse transition-colors"
                >
                  +62 812 5383 7777
                </a>
              </div>
              <div className="flex items-start gap-2">
                <span className="font-mono text-[10px] text-chartreuse w-8">Email</span>
                <a
                  href="mailto:ptagroteknologinusantara@gmail.com"
                  className="font-mono text-xs text-text-muted hover:text-chartreuse transition-colors leading-snug"
                >
                  ptagroteknologinusantara@gmail.com
                </a>
              </div>
              <div className="flex items-start gap-2">
                <span className="font-mono text-[10px] text-chartreuse w-8 shrink-0">Alamat</span>
                <span className="font-mono text-xs text-text-muted leading-snug">
                  Jl. Poros Samarinda Anggana, Sungai Meriam, Kec. Anggana, Kabupaten Kutai Kartanegara, Kalimantan Timur 75256
                </span>
              </div>
            </div>

            {/* Instagram */}
            <div className="mt-4 flex items-center gap-2">
              <span className="font-mono text-[10px] text-chartreuse">Instagram</span>
              <a
                href="https://instagram.com/agroteknologinusantara"
                target="_blank"
                rel="noopener noreferrer"
                className="font-mono text-xs text-text-muted hover:text-chartreuse transition-colors"
              >
                @agroteknologinusantara
              </a>
            </div>
          </div>
        </div>

        {/* Bottom rule */}
        <div className="border-t border-chartreuse/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          {/* Logo */}
          <div className="flex items-center gap-2">
            <AppImage
              src="/assets/images/logo/logo_atn2-03.png"
              alt="Agro Teknologi Nusantara"
              width={24}
              height={24}
              className="w-12 h-12 object-contain opacity-60" />
            <span className="font-mono text-text-muted/60 text-xs">| Agro Teknologi Nusantara</span>
          </div>
          <div className="font-mono text-xs text-text-muted/50 tracking-wider text-center sm:text-right">
            © 2026 Agro Teknologi Nusantara. All Rights Reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}
